<button 
  nbButton 
  [status]="status" 
  [size]="tamanho"
  (click)="iniciarTutorial()"
  [nbTooltip]="tooltip">
  <nb-icon [icon]="icone" *ngIf="icone"></nb-icon>
  <span *ngIf="texto">{{ texto }}</span>
</button> 